"use strict";

import angular from "angular";

function fixInputMaskDirective() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ctrl) {
            element.on("keyup", function (ev) {
                scope.$apply(function () {
                    if (isNaN(ctrl.$modelValue)) {
                        const value = `-0,${Number(ev.key)}0`;
                        ctrl.$setViewValue(value);
                        ctrl.$render();
                    }
                });
            });
        }
    };
}

const name = "fixInputMask";
const factory = fixInputMaskDirective;
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
